<template>
  <div class="event">
    <div class="pay">
      <Header :name="$t('payment.services.' + $route.params.payment)" :min="_.get(providerInfo, 'min_pay', '')" :max="_.get(providerInfo, 'max_pay', '')"/>
      <Validate :form="form" v-if="email_view"></Validate>
      <form v-else class="app-pay-form" @submit.prevent="send">
        <Loader v-if="loading" :style="!isMobile ? 'margin-top: -35px;margin-bottom: 50px;' : ''" />
        <slot v-else>
          <slot name="content"></slot>
          <div class="col">
            <div class="inline-form">
              <label>Coin Adresiniz</label>
              <input type="text" v-model="form.address" autocomplete="off">
            </div>
          </div>
          <div class="col">
            <div class="inline-form">
              <label>Coinler</label>
              <select v-model="form.coin">
                  <option :value="null" disabled>Seçiniz</option>
                  <option v-for="(value, key) in coins" :key="key" :value="key">{{ value }}</option>
              </select>
            </div>
          </div>
          <div class="col">
            <div class="inline-form">
              <label>Tutar</label>
              <input :type="isMobile ? 'tel' : 'number'" placeholder="Çekim tutarınızı yazınız" v-model="form.amount">
            </div>
          </div>
          <ButtonLoader class="primary block" :loader="btnLoading" :text="'Ödemeyi Başlat'" />
        </slot>
      </form>
    </div>
  </div>
</template>

<script>
  import Header from '../../../../components/User/Pay/Header'
  import Form from '../../../../components/User/Pay/Form'
  import Validate from '../../../../components/User/Pay/Validate'

  export default{
    props:['providerInfo'],
    data(){
      return{
        btnLoading: false,
        form: {
            coin:null,
            withdraw_validation_code:null,
            address: null,
            amount: null,
        },
        loading: false,
        coins   : [],
        email_view: false,
      }
    },
    created(){
      this.fetchData();
    },
    methods:{
      fetchData() {
          this.loading = true;
          axios.get('/user/wallet/deposit/kriptopay/coins')
            .then((response) => {
                if (response.data.status) {
                    this.coins = response.data.coins;
                };
            })
            .catch((err) => {
            })
            .finally(() => {
              this.loading = false;
            });
      },
      send() {
        this.btnLoading = true;
        axios.post('/user/wallet/deposit/kriptopay/create', this.form)
        .then((response) => {
          if(response.data.email_view){
            this.email_view = true
            this.$store.dispatch('alert/message', { type: 'success', msg: response.data.message })
            return false
          }
          if (response.data.status) {
            this.$store.dispatch('wallet/setToPending', true);
            window.open(response.data.url,'winname','directories=no,titlebar=no,toolbar=no,location=no,status=no,menubar=no,scrollbars=no,resizable=no,width=1200,height=800');
          }
        })
        .catch((err) => {
            if(err.response.data.email_verification){
              this.$router.push({ name: 'User', params: { section: 'security', payment: null } })
            }
        })
        .finally(() => {
          this.btnLoading = false;
        });
      },
    },
    components:{
      Header,
      Validate,
      Form
    }
  }

</script>